module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    attrs: {
      "id": "page-header"
    }
  }, [_c('div', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "content-header-section"
  }, [_c('button', {
    staticClass: "btn btn-circle btn-dual-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleSidebar
    }
  }, [_c('i', {
    staticClass: "fa fa-navicon"
  })]), _vm._v(" "), _c('nav', {
    staticClass: "breadcrumb"
  }, [_c('router-link', {
    staticClass: "breadcrumb-item",
    attrs: {
      "to": {
        name: 'dashboard'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _vm._v(" "), _c('span', {
    staticClass: "breadcrumb-item"
  }, [_vm._v("Magazijn")]), _vm._v(" "), _c('span', {
    staticClass: "breadcrumb-item"
  }, [_vm._v("Producten")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content-header-section"
  }, [_c('b-dropdown', {
    attrs: {
      "text": _vm.user.username,
      "variant": "dual-secondary",
      "right": ""
    }
  }, [_c('b-dropdown-item', {
    attrs: {
      "to": {
        name: 'settings'
      }
    }
  }, [_c('i', {
    staticClass: "si si-wrench mr-5"
  }), _vm._v(" Instellingen\n        ")]), _vm._v(" "), _c('b-dropdown-divider'), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "si si-logout mr-5"
  }), _vm._v(" Log uit\n        ")])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c902d0f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/partials/Header.vue
// module id = 732
// module chunks = 1